import { gql } from "@apollo/client";
import { System } from "./getSystemCall";

export const MAINTAIN_SYSTEM_INFO = gql`
  mutation Maintain($domain: String!, $system: MaintainSystemInput!) {
    system {
      maintain(domain: $domain, system: $system) {
        code
        success
        message
        updatedValues {
          system_id
          fk_system_types
          name
          default_amount
          min_feed_speed
          max_feed_speed
        }
      }
    }
  }
`

export interface MaintainSystemInput {
  system_id: number;
  name?: string; 
  default_amount?: number;
  min_feed_speed?: number;
  max_feed_speed?: number;
}

interface SystemMutationResponse {
  code: string;
  message: string;
  success: boolean;
  updatedValues?: System
}

export interface MaintainSystemResponse {
  system: {
    maintain: SystemMutationResponse;
  }
}